
export const getWindowDimensions = () => {
  const width = window.innerWidth;
  const height = window.innerHeight - 80;
  return {
    width,
    height,
  };
}